import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/firmware-landing/plCopy";

const ProgramowanieFirmwareBlePage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/programowanie-firmware-ble",
      lang: "pl",
      ogLocale: "pl_PL",
      structuredData: copy.structuredData,
      alternatePaths: {
        pl: "/programowanie-firmware-ble",
        en: "/firmware-development-company",
        xDefault: "/programowanie-firmware-ble",
      },
    }}
    alternateLanguage={{
      href: "/firmware-development-company",
      label: "EN",
    }}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default ProgramowanieFirmwareBlePage;
